// Browser and Cookie Detection for Build Team Portal
// Detects: Cookies disabled

(function() {
    'use strict';

    console.log('🔍 Running browser compatibility check...');

    function checkCookiesEnabled() {
        try {
            // Try to set a test cookie
            document.cookie = 'cookietest=1; SameSite=Lax; path=/';
            const cookiesEnabled = document.cookie.indexOf('cookietest=') !== -1;

            // Clean up test cookie
            document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT; SameSite=Lax; path=/';

            console.log('🍪 Cookies enabled:', cookiesEnabled);
            return cookiesEnabled;
        } catch (e) {
            console.error('❌ Cookie check failed:', e);
            return false;
        }
    }

    function blockAccess(reason) {
        console.error('🚫 BLOCKING ACCESS:', reason);
        // eslint-disable-next-line no-alert
        alert('Browser Setup Required\n\n' + reason + '\n\nYou will be redirected to setup instructions.');

        // Redirect to blocked page
        const currentPath = window.location.pathname;
        if (!currentPath.includes('/blocked')) {
            window.location.replace('/buildteam/blocked');
        }
    }

    // Run checks
    function runChecks() {
        try {
            // Check: Cookies must be enabled
            const cookiesEnabled = checkCookiesEnabled();
            if (!cookiesEnabled) {
                blockAccess('Cookies are disabled. Please enable cookies to continue.');
                return;
            }

            console.log('✅ Browser check passed - cookies enabled');
        } catch (error) {
            console.error('Error during browser check:', error);
        }
    }

    // Run checks immediately
    runChecks();
})();
